import { useRef } from "react";
import { Link } from "react-router-dom";
import { categoryLabel, imgProps } from "@/lib/api";

export const ProductCard = ({ product }) => {
  const frameRef = useRef(null);
  const finePointer =
    typeof window !== "undefined" && window.matchMedia("(pointer: fine)").matches;

  const tilt = (e) => {
    if (!finePointer || !frameRef.current) return;
    const r = frameRef.current.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    frameRef.current.style.transform = `perspective(900px) rotateY(${(x * 6).toFixed(2)}deg) rotateX(${(-y * 6).toFixed(2)}deg)`;
  };
  const reset = () => {
    if (frameRef.current) frameRef.current.style.transform = "";
  };

  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block transition-transform duration-500 ease-out hover:-translate-y-1.5"
    >
      {product.image ? (
        <div
          ref={frameRef}
          onMouseMove={tilt}
          onMouseLeave={reset}
          className="relative overflow-hidden bg-[#F4EEE3] transition-transform duration-300 ease-out"
        >
          <img
            {...imgProps(product.image, "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw")}
            alt={product.name}
            loading="lazy"
            className="block h-auto w-full"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#262019]/25 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
        </div>
      ) : (
        <div className="flex aspect-video flex-col items-center justify-center gap-4 border border-[#A58343]/20 bg-[#F4EEE3]" data-testid={`product-placeholder-${product.slug}`}>
          <span className="font-serif text-6xl font-light italic text-[#A58343]/50">M</span>
          <p className="px-6 text-center text-[10px] uppercase tracking-[0.3em] text-[#7C7163]">
            Photography arriving soon
          </p>
        </div>
      )}
      <div className="mt-6">
        <p className="overline !text-[10px]">{categoryLabel(product.category)}</p>
        <h3 className="mt-2 font-serif text-2xl font-medium text-[#262019] transition-colors duration-300 group-hover:text-[#A58343]">
          {product.name}
        </h3>
      </div>
    </Link>
  );
};
